import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=34759b40&scoped=true&"
import script from "./rule.vue?vue&type=script&lang=js&"
export * from "./rule.vue?vue&type=script&lang=js&"
import style0 from "./rule.vue?vue&type=style&index=0&id=34759b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34759b40",
  null
  
)

export default component.exports